import HttpService from "@/utils/httpData"

export const saveClassSchool = params => {
    let apiEndpoint = `ClassSchool/Create`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const listClassSchool = params => {
    let apiEndpoint = `ClassSchool/List`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const getListClassSchoolMember = params => {
    let apiEndpoint = `ClassSchool/GetListClassSchoolMember`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const joinMemberToClassSchoolService = params => {
    let apiEndpoint = `ClassSchool/JoinMemberToClassSchool`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const leaverClassSchool = classSchoolId => {
    let apiEndpoint = `ClassSchool/LeaverClassSchool?classSchoolId=${classSchoolId}`;
    return HttpService.get(apiEndpoint).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const getDetail = id => {
    let apiEndpoint = `ClassSchool/detail?id=${id}`;
    return HttpService.get(apiEndpoint).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}
export const deleteClassSchool = id => {
    let apiEndpoint = `ClassSchool/Delete?id=${id}`;
    return HttpService.get(apiEndpoint).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const getListClassAndGroupByTeacherIdAssign = (params) => {
    let apiEndpoint = `ClassSchool/GetListClassAndGroupByTeacherIdAssign`;
    return HttpService.post(apiEndpoint,params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const checkDuplicate = params => {
    let apiEndpoint = `ClassSchool/CheckDuplicate`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}
